export default __webpack_public_path__ + "static/media/Kateryna_Milevskaya.d21a9bd6.png";